import placeholder from '../assets/images/placeholder.jpeg';
import { IMG_URL } from '../configs/app-global';

// export default function getImage(url) {
//   if (!url) {
//     return placeholder;
//   }
//   return IMG_URL + url;
// }

export default function getImage(url) {
  if (!url) {
    return placeholder;
  }


  if (/^https?:\/\//.test(url)) {
    return url;
  }


  return IMG_URL + url;
}
